__webpack_require__.p = "https://tuksums.lv/";